﻿export function extractKeys(keyPath: string[], object: any, list: string[][]) {
    const value = object[keyPath[keyPath.length - 1]];
    if (value === null || value === undefined || typeof value !== 'object' || Array.isArray(value)) {
        list.push([...keyPath]);
    } else {
        for (const key of Object.keys(value)) {
            extractKeys([...keyPath, key], value, list);
        }
    }
}

export function extractKeyPaths<T>(keys: Array<Extract<keyof T, string>>, userSettings: T) {
    const paths: string[][] = [];
    for (const key of keys) {
        extractKeys([key], userSettings, paths);
    }
    return paths;
}

export function createSettingsPath(path: string[]) {
    return {
        key: path.join('.'),
        setter: function (target: any, value: any) {
            for (let i = 0; i < path.length - 1; i++) {
                target = target[path[i]];
            }
            target[path[path.length - 1]] = value;
        },
        getter: (target: any) => path.reduce((p, c) => p[c], target)
    };
}
